import { string, object } from 'yup'

export const HolidaysSchema = object().shape({
  name: string().trim().required('Name is required'),
  date: string().trim().required('Date is required').nullable()
})
